import "slick-carousel";
import $ from "jquery";

$(() => {
  const spineSlider = $(".js-timeline-spines");
  const bookSlider = $(".js-timeline-books");

  if (!spineSlider.length || !bookSlider.length) {
    return;
  }

  let resizeTimer;
  $(window).on("resize.timeline", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      spineSlider.slick("setPosition");
      bookSlider.slick("setPosition");
    }, 200);
  });

  spineSlider.slick({
    arrows: true,
    dots: false,
    centerMode: true,
    infinite: false,
    slidesToShow: 5,
    focusOnSelect: true,
    variableWidth: true,
    initialSlide: 0,
    centerPadding: "0px",
    asNavFor: ".js-timeline-books",
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
  });

  bookSlider.slick({
    arrows: false,
    dots: false,
    centerMode: true,
    infinite: false,
    slidesToShow: 1,
    swipe: false,
    draggable: false,
    touchMove: false,
    initialSlide: 0,
    centerPadding: "0px",
    asNavFor: ".js-timeline-spines",
  });
});
